module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid-filters/datagrid-filters.component.html
// module id = ./libs/atenea-cms/src/datagrid/datagrid-filters/datagrid-filters.component.html
// module chunks = main